import { ofType } from "redux-observable";
import { of } from "rxjs";
import {
  map,
  mergeMap,
  switchMap,
  ignoreElements,
  tap,
  catchError,
  concat
} from "rxjs/operators";
import { push } from "react-router-redux";

import * as Consts from "../config";
import { notification } from "antd";

import { FORM_ERROR } from "final-form";
import {
  LOGIN_FORM_REQUEST_ACTION,
  loginFormSuccess,
  loginFormFailure,
  forgotPasswordFormFailure,
  forgotPasswordFormSuccess,
  FORGOT_FORM_REQUEST_ACTION,
  RESET_PASSWORD_FORM_REQUEST_ACTION,
  resetPasswordFormSuccess,
  resetPasswordFormFailure,
  loginFormRequest
} from "../ducks/login";
import {
  LOGOUT_REQUEST_ACTION,
  logoutSuccess,
  LOGIN_REQUEST_ACTION,
  LOGIN_SUCCESS_ACTION,
  loginRequest,
  LOGIN_FAILURE_ACTION,
  loginSuccess,
  loginFailure,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  FORGOT_PASSWORD_REQUEST_ACTION,
  forgotPasswordRequest,
  FORGOT_PASSWORD_SUCCESS_ACTION,
  FORGOT_PASSWORD_FAILURE_ACTION,
  RESET_PASSWORD_SUCCESS_ACTION,
  RESET_PASSWORD_FAILURE_ACTION,
  resetPasswordRequest,
  RESET_PASSWORD_REQUEST_ACTION,
  resetPasswordFailure,
  resetPasswordSuccess
} from "../ducks/data";
import loginService from "../services/loginService";
import { parseError } from "./lib";
const jwtDecode = require("jwt-decode");

export const logoutEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOGOUT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      window.localStorage.setItem("app.Authorization", "");
      window.localStorage.setItem("app.Roles", "");
      window.localStorage.setItem("app.UserId", "");

      return [push("/login"), logoutSuccess()];
    })
  );

export const loginFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOGIN_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(loginRequest(action.payload));
    })
  );

export const loginFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOGIN_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const users = action.payload.user;
      return of(loginFormSuccess(users));
    })
  );

export const loginFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOGIN_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // Send message back to form
      let errors = {
        [FORM_ERROR]: "You have entered an invalid username or password"
      };
      return of(loginFormFailure(errors));
    })
  );

export const loginEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOGIN_REQUEST_ACTION.getType()),
    mergeMap(action =>
      loginService.login(action.payload).pipe(
        mergeMap(response => {
          if (response.errors) {
            return of(loginFailure(parseError(response)));
          } else {
            window.localStorage.setItem(
              "app.Authorization",
              response.response.token
            );
            let userResponse = response.response.user;

            var decoded = jwtDecode(response.response.token);
            let roles =
              (decoded.roles &&
                decoded.roles.map(role => role.toUpperCase())) ||
              [];

            if (decoded.god) {
              roles.push(Consts.UserPermission.SuperAdmin);
            }
            window.localStorage.setItem("app.Roles", roles.join(","));
            window.localStorage.setItem("app.UserId", userResponse.id);

            return [loginSuccess(response), push("/dashboard")];
          }
        }),
        catchError(error => {
          return of(loginFailure(error));
        })
      )
    )
  );

export const forgotPasswordFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(FORGOT_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(forgotPasswordRequest(action.payload));
    })
  );

export const forgotPasswordFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(FORGOT_PASSWORD_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const users = action.payload.user;
      return of(forgotPasswordFormSuccess(users));
    })
  );

export const forgotPasswordFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(FORGOT_PASSWORD_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // Send message back to form
      let errors = {
        [FORM_ERROR]: "Email has attempted to send. Please check your email."
      };
      return of(forgotPasswordFormFailure(errors));
    })
  );

export const forgotPasswordEpic = (action$, state$) =>
  action$.pipe(
    ofType(FORGOT_PASSWORD_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return loginService
        .forgotPassword(action.payload)
        .then(response => {
          if (response.data.errors) {
            return forgotPasswordFailure(parseError(response));
          } else {
            return forgotPasswordSuccess(response.data);
          }
        })
        .catch(error => {
          return forgotPasswordFailure(error);
        });
    })
  );

export const resetPasswordFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(RESET_PASSWORD_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(resetPasswordRequest(action.payload));
    })
  );

export const resetPasswordFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(RESET_PASSWORD_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return of(loginFormRequest(action.payload.accounts));
    })
  );

export const resetPasswordFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(RESET_PASSWORD_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // Send message back to form
      let errors = {
        [FORM_ERROR]: "Failed to reset password."
      };
      return of(resetPasswordFormFailure(errors));
    })
  );

export const resetPasswordEpic = (action$, state$) =>
  action$.pipe(
    ofType(RESET_PASSWORD_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return loginService
        .resetPassword(action.payload)
        .then(response => {
          if (response.data.errors) {
            return resetPasswordFailure(parseError(response));
          } else {
            return resetPasswordSuccess(action.payload);
          }
        })
        .catch(error => {
          return resetPasswordFailure(error);
        });
    })
  );



// WEBPACK FOOTER //
// ./src/epics/login.js